import { render, staticRenderFns } from "./FourthOne.vue?vue&type=template&id=39e3e494&lang=pug&"
import script from "./FourthOne.vue?vue&type=script&lang=js&"
export * from "./FourthOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports